/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IRegimen } from 'app/shared/model/regimen.model';

export interface IRegimenCycle {
  id?: string;
  name?: string | null;
  description?: string | null;
  cycleNumber?: number | null;
  duration?: number | null;
  durationUnit?: string | null;
  frequency?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  treatmentType?: IClinicalDictionary | null;
  regimen?: IRegimen | null;
}

export const defaultValue: Readonly<IRegimenCycle> = {
  active: false,
};
